
import React from "react";

const MapLoadingOverlay: React.FC = () => {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-gray-50/50 dark:bg-gray-800/50 z-10">
      <div className="text-center p-6 rounded-lg bg-white dark:bg-gray-700 shadow-md">
        <h3 className="text-lg font-semibold mb-2">Loading Map</h3>
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary mx-auto"></div>
        <p className="mt-2 text-sm text-muted-foreground">Please wait while we load the map...</p>
      </div>
    </div>
  );
};

export default MapLoadingOverlay;
